/** Re-export of shared company policy persistence logic (see convex/model/policies). */
export * from "../../convex/model/policies";

import type { PolicyStatus } from "../../convex/model/enums";
import type { PolicyLibraryStatusFilter } from "../../convex/model/policies";

const POLICY_STATUS_LABELS = {
  active: "Active",
  draft: "Draft",
  archived: "Archived",
} satisfies Record<PolicyStatus, string>;

const POLICY_STATUS_TONES = {
  active: "bg-emerald-50 text-emerald-700 ring-emerald-200",
  draft: "bg-amber-50 text-amber-700 ring-amber-200",
  archived: "bg-slate-50 text-slate-600 ring-slate-200",
} satisfies Record<PolicyStatus, string>;

export const policyStatusLabel = (status: PolicyStatus): string =>
  POLICY_STATUS_LABELS[status];

export const policyStatusToneClass = (status: PolicyStatus): string =>
  POLICY_STATUS_TONES[status];

export const policyLibraryStatusFilterOptions = [
  "all",
  "active",
  "draft",
  "archived",
] as const satisfies readonly PolicyLibraryStatusFilter[];

export type PolicyLibraryStatusFilterButtonState = "selected" | "idle";

export type PolicyLibraryStatusFilterButtonInput = {
  readonly current: PolicyLibraryStatusFilter;
  readonly option: PolicyLibraryStatusFilter;
};

const POLICY_LIBRARY_STATUS_FILTER_BUTTON_CLASSES = {
  selected: "bg-white text-slate-900 shadow-sm ring-1 ring-slate-200",
  idle: "text-slate-500 hover:text-slate-800",
} satisfies Record<PolicyLibraryStatusFilterButtonState, string>;

export const policyLibraryStatusFilterLabel = (status: PolicyLibraryStatusFilter): string =>
  status === "all" ? "All" : policyStatusLabel(status);

export const policyLibraryStatusFilterButtonState = ({
  current,
  option,
}: PolicyLibraryStatusFilterButtonInput): PolicyLibraryStatusFilterButtonState =>
  current === option ? "selected" : "idle";

export const policyLibraryStatusFilterButtonClass = (
  input: PolicyLibraryStatusFilterButtonInput,
): string =>
  POLICY_LIBRARY_STATUS_FILTER_BUTTON_CLASSES[policyLibraryStatusFilterButtonState(input)];
